export type DropdownOption = {
  label: string
  value: string
}

export enum SelectableOptionsEnum {
  CHECKED = 'checked',
  UNCHECKED = 'unchecked',
}
